import css from '@emotion/css';
import styled from '@emotion/styled';

export const EditableItemContainer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
`;

export const EditableItemThreeDotContainer = styled.div`
  margin-left: auto;
  ${({ child }) =>
    child
      ? css`
          margin-right: 10px;
        `
      : ''}

  &&& i {
    color: var(--color-background-dark);
  }

  &&& i:hover {
    color: var(--color-background-darker);
  }
`;
